import React, { useEffect, useState } from "react";

import MainLayout from "../../layouts/MainLayout";

import SideBar from "../../subcomponents/questionnaire/SideBar";
import Section from "../../subcomponents/questionnaire/section/Section";
import Page from "../../subcomponents/questionnaire/page/Page";

import useQuestionnaireContent from "../../../hooks/questionnaires/useQuestionnaireContent";
import { ISection } from "../../../types/section";
import DeleteModal from "../../modals/DeleteModal";
import Question from "../../subcomponents/questionnaire/question/Question";
import useGetCriteriaGroup from "../../../hooks/criteria-group/useGetCriteriaGroup";
import useGetQuestionOptions from "../../../hooks/question-options/useGetQuestionOptions";
import useGetRepeats from "../../../hooks/repeat/useGetRepeats";
import { useParams } from "react-router-dom";

const Questionnaire = () => {
  const [currOption, setCurrOption] = useState<number[]>([]);
  const [sections, setSections] = useState<ISection[]>([]);
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState<boolean>(false);
  const [isDelete, setIsDelete] = useState<boolean>(false);

  useEffect(() => {
    setCurrOption([0]);
  }, []);

  const params = useParams();
  const { data, refetch, isPending, isError } = useQuestionnaireContent();


  const {
    data: criteriaGroups,
    refetch: refetchCriteriaGroups,
    isPending: isCriteriaGroupsPending,
    isError: isCriteriaGroupsError,
  } = useGetCriteriaGroup();

  useEffect(() => {
    if (params.questcode) {
      refetch();
      refetchCriteriaGroups();
      setCurrOption([0]);
    }

  }, [params.questcode]) // eslint-disable-line

  const {
    data: questionOptions,
    isPending: isQuestionOptionsPending,
    isError: isQuestionOptionsError,
  } = useGetQuestionOptions();

  const {
    data: repeats,
    isPending: isRepeatsPending,
    isError: isRepeatsError,
  } = useGetRepeats();

  const sortArrByOrder = (arr: ISection[]) => {
    const sortedArr = arr
      .map((section) => {
        const pages = section.pages
          .map((page) => {
            const questions = page.questions.sort((a, b) => a.order - b.order);
            return {
              ...page,
              questions,
            };
          })
          .sort((a, b) => a.order - b.order);
        return {
          ...section,
          pages,
        };
      })
      .sort((a, b) => a.order - b.order);
    return sortedArr;
  };

  useEffect(() => {
    if (!isError && !isPending) setSections([...sortArrByOrder(data.sections)]);
  }, [data, isPending, isError]);

  if (isPending || isCriteriaGroupsPending || isQuestionOptionsPending || isRepeatsPending)
    return <p>Loading...</p>;
  if (isError || isCriteriaGroupsError || isQuestionOptionsError || isRepeatsError || !sections)
    return <p>Error!!</p>;

  return (
    <MainLayout>
      {isOpenDeleteModal && (
        <DeleteModal
          setIsOpenDeleteModal={setIsOpenDeleteModal}
          setIsDelete={setIsDelete}
          title="Are you sure you?"
          subtitle="This is an irrecoverable action. All data will be lost."
        />
      )}
      <div className="imm_quest_admin__main_view">
        <SideBar
          currOption={currOption}
          setSections={setSections}
          setCurrOption={setCurrOption}
          sections={sections}
        />
        <div className="imm_quest_admin__main_content">
          {currOption.length === 1 && (
            <Section
              currOption={currOption}
              setCurrOption={setCurrOption}
              sections={sections}
              isDelete={isDelete}
              setIsDelete={setIsDelete}
              setIsOpenDeleteModal={setIsOpenDeleteModal}
              criteriaGroups={criteriaGroups}
            />
          )}
          {currOption.length === 2 && (
            <Page
              currOption={currOption}
              setCurrOption={setCurrOption}
              sections={sections}
              isDelete={isDelete}
              setIsDelete={setIsDelete}
              setIsOpenDeleteModal={setIsOpenDeleteModal}
              criteriaGroups={criteriaGroups}
            />
          )}
          {currOption.length === 3 && (
            <Question
              currOption={currOption}
              setCurrOption={setCurrOption}
              sections={sections}
              isDelete={isDelete}
              setIsDelete={setIsDelete}
              setIsOpenDeleteModal={setIsOpenDeleteModal}
              criteriaGroups={criteriaGroups}
              questionOptions={questionOptions}
              repeats={repeats}
            />
          )}
        </div>
      </div>
    </MainLayout>
  );
};

export default Questionnaire;
